// @scripts
import {
    FORM_MODAL_DIALOG_VALID,
    SHOW_MODAL_DIALOG,
    HIDE_MODAL_DIALOG
} from '../actions';
import { config } from '../config';
import { format } from '../helpers';

/**
 * @return {{isVisible: boolean, msg: string, onConfirm: function}}
 */
export const modalDialogReducer = (
    state = config.initialState.modalDialog, action
) => {
    switch (action.type) {
        case SHOW_MODAL_DIALOG:
            const {
                cancelLabel,
                okLabel,
                showCancel,
                style,
                title,
                width
            } = action.payload;
            const msgArgs = [].concat(action.payload.msgArgs || []);
            const msg = Boolean(action.payload.msg) && Boolean(msgArgs.length)
                ? format(action.payload.msg, ...msgArgs)
                : action.payload.msg;
            return {
                cancelLabel,
                formValid: true,
                isVisible: true,
                msg,
                okLabel,
                onConfirm: action.payload.onConfirm,
                showCancel,
                style,
                title,
                width
            };
        case HIDE_MODAL_DIALOG:
            return {
                ...state,
                isVisible: false,
                msg: null,
                style: null,
                onConfirm: null
            };
        case FORM_MODAL_DIALOG_VALID:
            return {
                ...state,
                formValid: action.payload
            };
        default:
            return state;
    }
};
